/**
 * Benchmark Static Replay UI — main entry point.
 * Pure static: no WebSocket, no backend server.
 * ReplayEngine runs in the browser, data loaded via fetch().
 */

import "./styles/base.css";
import "./styles/layout.css";
import "./styles/timeline.css";
import { createAppController } from "./app-controller.js";
import {
  hideComparison,
  hideRunPicker,
  renderComparison,
  renderReplayControls,
  renderRunPicker,
  renderScaffold,
  resetPaneUI,
  setReplayAnimationSpeed,
  showTimeline,
  upsertEventNode,
  updatePaneTimer,
  updateReplayProgress,
  updateRunButton,
} from "./render.js";
import { StateStore } from "./state.js";
import { ReplayManager } from "./replay-manager.js";

const store = new StateStore();

// ─── Render scaffold ─────────────────────────────────────────
const app = document.getElementById("app")!;
renderScaffold(app);

// ─── Replay Manager (replaces WebSocket + server) ────────────
const controller = createAppController({
  store,
  render: {
    hideComparison,
    hideRunPicker,
    renderComparison,
    renderReplayControls,
    renderRunPicker,
    resetPaneUI,
    setReplayAnimationSpeed,
    showTimeline,
    upsertEventNode,
    updatePaneTimer,
    updateReplayProgress,
    updateRunButton,
    showError,
  },
});

const manager = new ReplayManager((msg) => {
  controller.handleServerMessage(msg);
});

// Wire up manager to controller
controller.setReplayManager(manager);

// ─── Bind DOM events ─────────────────────────────────────────

document.getElementById("btn-replay")!.addEventListener("click", () => {
  controller.handleReplayButton();
});

document.addEventListener("click", (e) => {
  controller.handleDocumentClick(e.target as HTMLElement);
});

document.addEventListener("click", (e) => {
  controller.handleReplaySeek(e.target as HTMLElement, e.clientX);
});

// ─── Error display ───────────────────────────────────────────

function showError(message: string) {
  const toast = document.createElement("div");
  toast.style.cssText = `
    position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%);
    background: rgba(239,68,68,0.9); color: #fff; padding: 12px 24px;
    border-radius: 8px; font-size: 14px; z-index: 100; max-width: 500px;
    animation: fadeIn 0.3s ease;
  `;
  toast.textContent = message;
  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 5000);
}

// ─── Load initial data ───────────────────────────────────────
manager.loadManifest().then((runs) => {
  store.update({ availableRuns: runs });
});
